export const lang = {
	// 繁中
	'zh-tw': {
		'giftCode': '禮包碼兌換',
		'game': '遊戲',
		'server': '伺服器',
		'character': '角色名',
		'code': '兌換碼',
		'insertGift': '請輸入兌換碼',
		'confirm': '確認兌換',
		'find': '您可通過以下方式找到您的資訊',
		'step1': '步驟1：點擊頭像',
		'step2': '步驟2：點擊複製按鈕賦值角色名',
		'needLoginGameStep2': '步驟2：確認您的角色資訊',
		'invalidCode': '兌換碼無效',
		'characterNotFound': '沒有找到您的角色，請確認是否輸入錯誤',
		'done': '兌換成功！',
		'fail': '兌換失敗！',
		'pleaseSelectServer': '請選擇伺服器',
		'pleaseInputRole': '請輸入角色名',
		'inputToServer': '輸入以檢索伺服器',
		'codeUsed': '兌換碼使用次數已達上限',
		'validRole': '請先驗證角色',
		'validToGet': '該禮包價值較高，請先驗證角色後領取。',
		'goToValid': '前往驗證',
		'changeAccount': '切換帳號',
		"frequently" : "过于频繁操作，请稍候再试",
		'-20005':'兌獎失敗，請確認角色資訊（-20005）',
		'-20006':'兌獎失敗，請確認帳號（-20006）',
		'-20007':'兌獎失敗，請確認伺服器（-20007）'
	},
	// 简中
	'zh-cn': {
		'giftCode': '礼包码兑换',
		'game': '游戏',
		'server': '服务器',
		'character': '角色名',
		'code': '兑换码',
		'insertGift': '请输入兑换码',
		'confirm': '确认兑换',
		'find': '您可通过以下方式找到您的信息',
		'step1': '步骤1:点击头像',
		'step2': '步骤2:点击复制按钮复制信息',
		'needLoginGameStep2': '步骤2:确认您的角色信息',
		'invalidCode': '兑换码无效',
		'characterNotFound': '没有找到您的角色，请确认是否输入错误',
		'done': '兑换成功！',
		'fail': '兑换失败！',
		'pleaseSelectServer': '请选择服务器',
		'pleaseInputRole': '请输入角色名',
		'inputToServer': '输入以搜索服务器',
		'codeUsed': '兑换码使用次数已达上限',
		'validRole': '请先验证角色',
		'validToGet': '该礼包价值较高，请先验证角色后领取。',
		'goToValid': '前往验证',
		'changeAccount': '切换帐号',
		"frequently" : "過於頻繁操作，請稍候再試",
		'-20005':'兑奖失败，请确认角色信息（-20005）',
		'-20006':'兑奖失败，请确认帐号（-20006）',
		'-20007':'兑奖失败，请确认伺服器（-20007）'
	},
	// 英语
	'en-us': {
		'giftCode': 'Gift Code',
		'game': 'Game',
		'server': 'Server',
		'character': 'Character',
		'code': 'Code',
		'insertGift': 'Please insert gift code',
		'confirm': 'Confirm',
		'find': 'Where to find your account information:',
		'step1': 'STEP 1: Tap your avatar',
		'step2': 'STEP 2: Tap the button to copy your character name',
		'needLoginGameStep2': 'STEP 2: Confirm Your Character Information',
		'invalidCode': 'Invalid code',
		'characterNotFound': 'Character not found. Please make sure you have entered the correct information',
		'done': 'Done!',
		'fail': 'Failed!',
		'pleaseSelectServer': 'Select Server',
		'pleaseInputRole': 'Insert character name',
		'inputToServer': 'Search Server',
		'codeUsed': 'Code used up',
		'validRole': 'Please verify your character first.',
		'validToGet': 'You must verify your character before claiming this pack.',
		'goToValid': 'Verify',
		'changeAccount': 'Switch Account',
		"frequently" : "Operation too frequent. Please try again later.",
		'-20005':'Failed to redeem. Please confirm your character info. (-20005)',
		'-20006':'Failed to redeem. Please confirm your account first. (-20006)',
		'-20007':'Failed to redeem. Please confirm your server first. (-20007)'
	},
	// 德语
	'de-de': {
		'giftCode': 'Geschenk-Code',
		'game': 'Spiel',
		'server': 'Server',
		'character': 'Charakter',
		'code': 'Code',
		'insertGift': 'Bitte Geschenk-Code eingeben',
		'confirm': 'Bestätigen',
		'find': 'Wo du deine Kontoinformationen findest:',
		'step1': 'Schritt 1: Tippe auf deinen Avatar',
		'step2': 'Schritt 2: Tippen, um deinen Charakternamen zu kopieren',
		'needLoginGameStep2': 'Schritt 2: Bestätige deine Charakterinformationen',
		'invalidCode': 'Ungültiger Code',
		'characterNotFound': 'Zeichen nicht gefunden. Bitte stelle sicher, dass du die richtigen Informationen eingegeben hast',
		'done': 'Erledigt!',
		'fail': 'Fehlgeschlagen!',
		'pleaseSelectServer': 'Wähle Server',
		'pleaseInputRole': 'Charakternamen eingeben',
		'inputToServer': 'Suche Server',
		'codeUsed': 'Code verbraucht',
		'validRole': 'Bitte verifiziere zuerst deinen Charakter.', 
		'validToGet': 'Du musst deinen Charakter verifizieren, bevor du dieses Paket abholen kannst.', 
		'goToValid': 'Verifizieren', 
		'changeAccount': 'Konto wechseln',
		"frequently" : "Durchführung zu oft. Bitte versuche es später erneut.",
		'-20005':'Fehler beim Einlösen. Bitte bestätige deine Charakterinformationen. (-20005)',
		'-20006':'Fehler beim Einlösen. Bitte bestätige zuerst dein Konto. (-20006)',
		'-20007':'Fehler beim Einlösen. Bitte bestätige zuerst deinen Server. (-20007)'
	},
	// 法语
	'fr-fr': {
		'giftCode': 'Code cadeau',
		'game': 'Jeu',
		'server': 'Serveur',
		'character': 'Personnage',
		'code': 'Code',
		'insertGift': 'Saisissez le code cadeau',
		'confirm': 'Confirmer',
		'find': 'Où trouver les infos de votre compte :',
		'step1': 'Étape 1 : Appuyez sur votre avatar',
		'step2': 'Étape 2 : Appuyez sur le bouton pour copier le nom de votre personnage',
		'needLoginGameStep2': 'Étape 2 : Confirmez les informations de votre personnage',
		'invalidCode': 'Code invalide',
		'characterNotFound': 'Personnage introuvable. Assurez-vous que les infos saisies sont correctes',
		'done': 'Terminé !',
		'fail': 'Échec !',
		'pleaseSelectServer': 'Sélectionner un serveur',
		'pleaseInputRole': 'Insérer un nom de personnage',
		'inputToServer': 'Chercher un serveur',
		'codeUsed': 'Code déjà utilisé',
		'validRole': `Veuillez d'abord vérifier votre personnage.`, 
		'validToGet': 'Vous devez vérifier votre personnage avant de réclamer ce pack.', 
		'goToValid': 'Vérifier', 
		'changeAccount': 'Switch Account',
		"frequently" : "Opération trop fréquente. Veuillez réessayer plus tard.",
		'-20005':"Échec de l'échange. Veuillez confirmer les informations de votre personnage. (-20005)",
		'-20006':"Échec de l'échange. Veuillez d'abord confirmer votre compte. (-20006)",
		'-20007':"Échec de l'échange. Veuillez d'abord confirmer votre serveur. (-20007)",
	},
	// 俄语
	'ru-ru': {
		'giftCode': 'Подарочный Код',
		'game': 'Игра',
		'server': 'Сервер',
		'character': 'Персонаж',
		'code': 'Код',
		'insertGift': 'Введите Подарочный Код',
		'confirm': 'Подтвердить',
		'find': 'Как узнать информацию об аккаунте:',
		'step1': 'Шаг 1: нажмите на свой аватар',
		'step2': 'Шаг 2: нажмите на кнопку, чтобы скопировать имя вашего персонажа',
		'needLoginGameStep2': 'Шаг 2: Подтвердите информацию о вашем персонаже',
		'invalidCode': 'Неверный Код',
		'characterNotFound': 'Персонаж не найден. Убедитесь, что вы ввели правильную информацию',
		'done': 'Сработало!',
		'fail': 'Неудача!',
		'pleaseSelectServer': 'Выберите Сервер',
		'pleaseInputRole': 'Введите имя персонажа',
		'inputToServer': 'Поиск Сервера',
		'codeUsed': 'Исчерпан лимит ввода кода',
		'validRole': 'Сначала нужно подтвердить своего персонажа.',
		'validToGet': 'Чтобы получить этот набор, нужно сначала подтвердить своего персонажа.',
		'goToValid': 'Подтвердить',
		'changeAccount': 'Switch Account',
		"frequently" : "Операция происходит слишком часто. Пожалуйста, попробуйте позже.",
		'-20005':'Активация не удалась. Пожалуйста, подтвердите информацию о персонаже. (-20005)',
		'-20006':'Активация не удалась. Пожалуйста, сначала подтвердите свою уч. запись. (-20006)',
		'-20007':'Активация не удалась. Пожалуйста, сначала подтвердите свой сервер. (-20007)'
	},
	// 土耳其语
	'tr-tr': {
		'giftCode': 'Hediyes Kodu',
		'game': 'Oyun',
		'server': 'Sunucu',
		'character': 'Karakter',
		'code': 'Kod',
		'insertGift': 'Hediye kodunu girin',
		'confirm': 'Onayla',
		'find': 'Hesap bilgilerinizi bulabileceğiniz yer:',
		'step1': 'Adım 1: Avatarınıza tıklayın',
		'step2': 'Adım 2: Karakter adınızı kopyalamak için butona tıklayın',
		'needLoginGameStep2': 'Adım 2: Karakter Bilgilerinizi Onaylayın',
		'invalidCode': 'Geçersiz kod',
		'characterNotFound': 'Karakter bulunmadı. Bilgilerin doğruluğundan emin olun.',
		'done': 'Bitti!',
		'fail': 'Başarısız!',
		'pleaseSelectServer': 'Sunucu seç',
		'pleaseInputRole': 'Karakter adı gir',
		'inputToServer': 'Sunucu Ara',
		'codeUsed': 'Kod kullanıldı',
		'validRole': 'Lütfen önce karakteri doğrula.',
		'validToGet': 'Bu paketi talep etmeden önce karakterinizi doğrulaman gerekir.',
		'goToValid': 'Doğrula',
		'changeAccount': 'Hesap Değiştir',
		"frequently" : "İşlem çok sık. Lütfen daha sonra tekrar deneyin.",
		'-20005':'Kullanılamadı. Lütfen karakter bilgilerini onayla. (-20005)',
		'-20006':'Kullanılamadı. Lütfen önce hesabını onayla. (-20006)',
		'-20007':'Kullanılamadı. Lütfen önce sunucunu onayla. (-20007)'
	},
	// 西班牙语
	'es-es': {
		'giftCode': 'Código de Regalo',
		'game': 'Juego',
		'server': 'Servidor',
		'character': 'Personaje',
		'code': 'Código',
		'insertGift': 'Ingresa el Código de Regalo',
		'confirm': 'Confirmar',
		'find': 'Dónde encontrar la información de tu cuenta:',
		'step1': 'Paso 1: Toca tu avatar',
		'step2': 'Paso 2: Toca el botón para copiar el nombre de tu personaje',
		'needLoginGameStep2': 'Paso 2: Confirma la información de tu personaje',
		'invalidCode': 'Código Inválido',
		'characterNotFound': 'No se encontró al personaje. Asegúrate de que has ingresado la información correcta',
		'done': '¡Hecho!',
		'fail': '¡Falló!',
		'pleaseSelectServer': 'Selecciona un servidor',
		'pleaseInputRole': 'Ingresa el nombre del personaje',
		'inputToServer': 'Busca un servidor',
		'codeUsed': 'Código agotado',
		'validRole': 'Primero tienes que verificar tu personaje.',
		'validToGet': 'Para reclamar este paquete, primero debes verificar tu personaje.',
		'goToValid': 'Verificar',
		'changeAccount': 'Cambiar Cuenta',
		"frequently" : "Operación demasiado frecuente. Inténtalo de nuevo más tarde.",
		'-20005':'No se ha podido canjear. Confirma la información de tu personaje. (-20005)',
		'-20006':'No se ha podido canjear. Confirma primero tu cuenta. (-20006)',
		'-20007':'No se ha podido canjear. Confirma primero tu servidor. (-20007)'
	},
	// 葡萄牙语
	'pt-pt': {
		'giftCode': 'Código-presente',
		'game': 'Jogo',
		'server': 'Servidor',
		'character': 'Personagem',
		'code': 'Código',
		'insertGift': 'Por favor, insira o código-presente',
		'confirm': 'Confirmar',
		'find': 'Onde você pode encontrar informações sobre sua conta:',
		'step1': 'Passo 1: Toque em seu avatar',
		'step2': 'Passo 2: Toque no botão para copiar o nome do seu personagem',
		'needLoginGameStep2': 'Passo 2: Confirme as informações do seu personagem',
		'invalidCode': 'Código inválido',
		'characterNotFound': 'Personagem não encontrado. Verifique se as informações inseridas estão corretas',
		'done': 'Feito!',
		'fail': 'Falhou!',
		'pleaseSelectServer': 'Selecionar Servidor',
		'pleaseInputRole': 'Inserir nome de personagem',
		'inputToServer': 'Buscar Servidor',
		'codeUsed': 'O código já foi usado',
		'validRole': 'Por favor, verifique seu personagem primeiro.',
		'validToGet': 'Você deve verificar seu personagem antes de reivindicar este pacote.',
		'goToValid': 'Verificar',
		'changeAccount': 'Mudar de Conta',
		"frequently" : "Operation too frequent. Please try again later.",
		'-20005':'Falha ao resgatar. Por favor, confirme as informações do seu personagem. (-20005)',
		'-20006':'Falha ao resgatar. Por favor, confirme sua conta primeiro. (-20006)',
		'-20007':'Falha ao resgatar. Por favor, confirme seu servidor primeiro. (-20007)s'
	},
	// 日语
	'ja-jp': {
		'giftCode': 'ギフトコード交換',
		'game': 'ゲーム名',
		'server': 'サーバー名',
		'character': 'キャラクター名',
		'code': 'ギフトコード',
		'insertGift': '入力してください',
		'confirm': '確認',
		'find': '下記の方法でプレイヤー情報を確認できます',
		'step1': 'STEP1：アイコンをタップしてください',
		'step2': 'STEP2：キャラクター名をコピーしてください',
		'needLoginGameStep2': 'STEP2：キャラクター情報を確認してください',
		'invalidCode': '無効のギフトコードです',
		'characterNotFound': '正しいキャラクター名を入力してください',
		'done': '交換完了！',
		'fail': '交換失敗！',
		'pleaseSelectServer': 'サーバーを選択してください',
		'pleaseInputRole': 'キャラクター名を入力してくさい',
		'inputToServer': 'サーバー名を入力してください',
		'codeUsed': 'ギフトコードの使用回数が上限に達しました',
		'validRole': 'まずはキャラクターを連携してください。',
		'validToGet': '専用パックの受領にはキャラクターを連携する必要があります。',
		'goToValid': '連携へ',
		'changeAccount': 'アカウントの切り替え',
		"frequently" : "操作が頻繁すぎます。後ほどもう一度試してください。",
		'-20005':'交換に失敗しました。キャラクター情報を確認してください。（-20005）',
		'-20006':'交換に失敗しました。アカウントを確認してください。（-20006）',
		'-20007':'交換に失敗しました。サーバーを確認してください。（-20007）'
	},
	// 韩语
	'ko-kr': {
		'giftCode': '쿠폰 교환',
		'game': '게임',
		'server': '서버',
		'character': '캐릭터',
		'code': '쿠폰 번호',
		'insertGift': '쿠폰 번호를 입력하세요',
		'confirm': '확인',
		'find': '다음 방법에 따라 계정 정보를 확인할 수 있습니다.',
		'step1': '1. 프로필을 터치합니다.',
		'step2': '2. 복사 버튼을 터치해 캐릭터명을 복사합니다.',
		'needLoginGameStep2': '2. 캐릭터 정보를 확인하세요.',
		'invalidCode': '무효한 쿠폰 번호',
		'characterNotFound': '캐릭터를 찾지 못했습니다. 캐릭터명을 다시 확인하시기 바랍니다.',
		'done': '교환 성공',
		'fail': '교환 실패',
		'pleaseSelectServer': '서버를 선택하세요',
		'pleaseInputRole': '캐릭터명을 입력하세요',
		'inputToServer': '서버 검색을 위해 여기에 입력하세요',
		'codeUsed': '쿠폰 번호 사용 횟수 상한에 도달했습니다',
		'validRole': '먼저 로그인하세요',
		'validToGet': '해당 선물은 가치가 높으므로 로그인 후 수령하세요',
		'goToValid': '로그인',
		'changeAccount': '계정 변경',
		"frequently" : "조작이 잦습니다. 잠시 후 다시 시도하세요.",
		'-20005':'교환 실패. 캐릭터 정보를 확인하세요(-20005)',
		'-20006':'교환 실패. 올바른 계정을 입력했는지 확인하세요(-20006)',
		'-20007':'교환 실패. 올바른 서버를 입력했는지 확인하세요(-20007)'
	},
	// 泰语
	'th-th': {
		'giftCode': 'แลกของขวัญ',
		'game': 'เกมส์',
		'server': 'เซิร์ฟเวอร์',
		'character': 'ชื่อตัวละคร',
		'code': 'โค้ดของขวัญ',
		'insertGift': 'โปรดป้อนโค้ดของขวัญ',
		'confirm': 'ยืนยัน',
		'find': 'ท่านสามารถค้นหาข้อมูลของท่านได้โดย:',
		'step1': 'ขั้นที่ 1:คลิกรูปโปรไฟล์',
		'step2': 'ขั้นที่ 2:กดปุ่มคัดลอก เพื่อคัดลอกชื่อตัวละคร',
		'needLoginGameStep2': 'ขั้นที่ 2:ยืนยันข้อมูลตัวละครของคุณ',
		'invalidCode': 'โค้ดของขวัญไม่เป็นผล',
		'characterNotFound': 'พบตัวละครของท่าน โปรดตรวจสอบว่าป้อนถูกต้องหรือไม่',
		'done': 'แลกสำเร็จ!',
		'fail': 'แลกไม่สำเร็จ!',
		'pleaseSelectServer': 'โปรดเลือกเซิร์ฟ',
		'pleaseInputRole': 'โปรดป้อนชื่อตัวละคร',
		'inputToServer': 'ป้อนเซิร์ฟที่ต้องการค้นหา',
		'codeUsed': 'สิทธิ์ใช้โค้ดครบลิมิตแล้ว',
		'validRole': 'โปรดยืนยันตัวละครก่อน',
		'validToGet': 'แพ็กนี้มีมูลค่าค่อนข้างสูง โปรดยืนยันตัวละครก่อนรับ',
		'goToValid': 'ไปยืนยัน',
		'changeAccount': 'เปลี่ยนบัญชี',
		"frequently" : "ทำรายการบ่อยเกินไป โปรดลองใหม่ภายหลัง",
		'-20005':'แลกไม่สำเร็จ โปรดตรวจสอบข้อมูลตัวละคร (-20005)',
		'-20006':'แลกไม่สำเร็จ โปรดตรวจสอบบัญชี (-20006)',
		'-20007':'แลกไม่สำเร็จ โปรดตรวจสอบเซิร์ฟเวอร์ (-20007)'
	},
	// 越南语
	'vi-vn': {
		'giftCode': 'Đổi mã Giftcode',
		'game': 'Trò chơi',
		'server': 'Cụm SV',
		'character': 'Tên nhân vật',
		'code': 'Mã đổi ',
		'insertGift': 'Vui lòng điền mã đổi quà ',
		'confirm': 'Xác nhận ',
		'find': 'Bạn có thể tìm thông tin tài khoản của bạn qua các bước sau: ',
		'step1': 'Bước 1: Nhấp vào khung avatar',
		'step2': 'Bước 2: Sao chép tên nhân vật của bạn',
		'needLoginGameStep2': 'Bước 2: Xác nhận thông tin nhân vật của bạn',
		'invalidCode': 'Mã đổi quà vô hiệu',
		'characterNotFound': 'Tên nhân vật không tồn tại. Hãy kiểm tra lại tên nhân vật của bạn.',
		'done': 'Đổi thành công!',
		'fail': 'Đổi thất bại!',
		'pleaseSelectServer': 'Hãy chọn server',
		'pleaseInputRole': 'Hãy nhập tên nhân vật ',
		'inputToServer': 'Nhập để tìm server',
		'codeUsed': 'Số lần sử dụng đã đạt giới hạn',
		'validRole': 'Vui lòng xác minh nhân vật',
		'validToGet': 'Gói quà trị giá cao, vui lòng xác minh nhân vật để nhận',
		'goToValid': 'Xác minh',
		'changeAccount': 'Đổi tài khoản',
		"frequently" : "Operation too frequent. Please try again later.",
		'-20005':'Đổi thưởng thất bại, vui lòng xác nhận thông tin nhân vật (-20005)',
		'-20006':'Đổi thưởng thất bại, vui lòng xác nhận tài khoản (-20006)',
		'-20007':'Đổi thưởng thất bại, vui lòng xác nhận máy chủ (-20007)'
	},
	// 波兰语
	'pl-pl': {
		'giftCode': 'Kod Prezentu',
		'game': 'Gra',
		'server': 'Serwer',
		'character': 'Postać',
		'code': 'Kod',
		'insertGift': 'Wpisz kod prezentu',
		'confirm': 'Zatwierdź',
		'find': 'Gdzie znaleźć Twoje info konta:',
		'step1': 'Krok 1: Stuknij w swój awatar',
		'step2': 'Krok 2: Stuknij przycisk, aby skopiować nazwę Twojej postaci',
		'needLoginGameStep2': 'Krok 2: Potwierdź informacje o swojej postaci',
		'invalidCode': 'Nieprawidłowy kod',
		'characterNotFound': 'Nie znaleziono postaci. Upewnij się, że wprowadziłeś poprawne informacje',
		'done': 'Zrobione!',
		'fail': 'Nieudane!',
		'pleaseSelectServer': 'Wybierz serwer',
		'pleaseInputRole': 'Wpisz nazwę postaci',
		'inputToServer': 'Znajdź serwer',
		'codeUsed': 'Kod zużyty',
		'validRole': 'Najpierw zweryfikuj swoją postać.',
		'validToGet': 'Musisz zweryfikować swoją postać przed złożeniem wniosku o ten pakiet.',
		'goToValid': 'Weryfikuj',
		'changeAccount': 'Przełącz konto',
		"frequently" : "Operation too frequent. Please try again later.",
		'-20005':'Nieudana realizacja. Potwierdź info swojej postaci. (-20005)',
		'-20006':'Nieudana realizacja. Potwierdź najpierw swoje konto. (-20006)',
		'-20007':'Nieudana realizacja. Potwierdź najpierw swój serwer. (-20007)'
	},
	// 意大利语
	'it-it': {
		'giftCode': 'Nieudane!',
		'game': 'Gioco',
		'server': 'Server',
		'character': 'Personaggio',
		'code': 'Codice',
		'insertGift': 'Inserisci il codice regalo',
		'confirm': 'Conferma',
		'find': "Dove trovare l'informazione del tuo account:",
		'step1': 'Passo 1: Tocca il tuo avatar',
		'step2': 'Passo 2: Tocca il bottone per copiare il nome del tuo personaggio',
		'needLoginGameStep2': 'Passo 2: Conferma le informazioni del tuo personaggio',
		'invalidCode': 'Codice non valido',
		'characterNotFound': "Personaggio non trovato. Assicurati di aver inserito l'informazione corretta",
		'done': 'Fatto!',
		'fail': 'Fallito!',
		'pleaseSelectServer': 'Seleziona Server',
		'pleaseInputRole': 'Inserisci nome personaggio',
		'inputToServer': 'Ricerca Server',
		'codeUsed': 'Codice utilizzato',
		'validRole': 'Si prega di verificare prima il tuo personaggio.',
		'validToGet': 'Devi verificare il tuo personaggio prima di rivendicare questo pacchetto.',
		'goToValid': 'Verifica',
		'changeAccount': 'Cambia Account',
		"frequently" : "Operazione troppo frequente. Per favore riprova più tardi.",
		'-20005':"Impossibile rivendicare. Si prega di confermare l'info carattere. (-20005)",
		'-20006':'Impossible rivendicare. Conferma prima il tuo account. (-20006)',
		'-20007':'Impossible rivendicare. Conferma prima il tuo server. (-20007)'
	},
	// 荷兰语
	'nl-nl': {
		'giftCode': 'Geschenk Code',
		'game': 'Spel',
		'server': 'Server',
		'character': 'Karakter',
		'code': 'Code',
		'insertGift': 'Voer geschenk code in',
		'confirm': 'Bevestig',
		'find': 'Waar kun je jouw account informatie vinden:',
		'step1': 'STEP 1: Tik op je avatar',
		'step2': 'STEP 2: Tik op de knop om de naam van je karakter te kopiëren',
		'needLoginGameStep2': 'STEP 2: Bevestig je personagegegevens',
		'invalidCode': 'Ongeldige code',
		'characterNotFound': 'Karakter niet gevonden. Controleer of je de juiste informatie hebt ingevoerd',
		'done': 'Klaar!',
		'fail': 'Mislukt!',
		'pleaseSelectServer': 'Kies Server',
		'pleaseInputRole': 'Voer karakternaam in',
		'inputToServer': 'Zoek Server',
		'codeUsed': 'Code gebruikt',
		'validRole': 'Please verify your character first.', // 未有翻译，使用英语
		'validToGet': 'You must verify your character before claiming this pack.', // 未有翻译，使用英语
		'goToValid': 'Verify', // 未有翻译，使用英语
		'changeAccount': 'Switch Account', // 未有翻译，使用英语
		"frequently" : "Operación demasiado frecuente. Inténtalo de nuevo más tarde.", // 未有翻译，使用英语
		'-20005':'Inwisselen mislukt. Verifieer je karakter informatie. (-20005)',
		'-20006':'Inwisselen mislukt. Bevestig eerst je account. (-20006)',
		'-20007':'Inwisselen mislukt. Verifieer eerst je server. (-20007)'
	},
	// 印尼语
	'id-id': {
		'giftCode': 'Penukaran Kode Redeem',
		'game': 'Game',
		'server': 'Server',
		'character': 'Karakter',
		'code': 'Kode Redeem',
		'insertGift': 'Silakan masukkan Kode Redeem',
		'confirm': 'Konfirmasi',
		'find': 'Anda bisa menemukan info Anda via cara di bawah:',
		'step1': 'Langkah 1: Tekan avatar',
		'step2': 'Langkah 2: Tekan tombol untuk salin nama karakter',
		'needLoginGameStep2': 'Langkah 2: Konfirmasi Informasi Karakter Anda',
		'invalidCode': 'Kode Redeem tidak valid',
		'characterNotFound': 'Tidak menemukan karakter Anda, pastikan tidak salah input',
		'done': 'Berhasil tukar!',
		'fail': 'Gagal tukar!',
		'pleaseSelectServer': 'Silakan pilih server',
		'pleaseInputRole': 'Masukkan nama karakter',
		'inputToServer': 'Cari server',
		'codeUsed': 'Kode sudah digunakan',
		'validRole': 'Silakan verifikasi karakter.',
		'validToGet': 'Harga paket tersebut lebih tinggi. Silakan klaim setelah verifikasi karakter.',
		'goToValid': 'Verifikasi',
		'changeAccount': 'Ganti Akun',
		"frequently" : "Operation too frequent. Please try again later.",
		'-20005':'Penukaran gagal. Silakan pastikan info karakter (-20005)',
		'-20006':'Penukaran gagal. Silakan pastikan info akun (-20006)',
		'-20007':'Penukaran gagal. Silakan pastikan server (-20007)'
	},
	// 阿拉伯语
	'ar-sa': {
		'giftCode': 'رمز مبادلة الهدية',
		'game': 'اللعبة',
		'server': 'الخادم',
		'character': 'الشخصية',
		'code': 'الرمز',
		'insertGift': '',
		'confirm': 'تأكيد',
		'find': 'طريقة العثور على معلومات حسابك:',
		'step1': 'الخطوة الأولى:انقر على صورتك الرمزية',
		'step2': 'الخطوة الثانية:انقر لنسخ اسم الشخصية الخاصة بك',
		'needLoginGameStep2': 'الخطوة الثانية:أكد معلومات شخصيتك',
		'invalidCode': 'الرمز غير صحيح',
		'characterNotFound': 'لم يتم العثور على الشخصية. يرجى التأكد من إدخال المعلومات الصحيحة',
		'done': 'تم بنجاح!',
		'fail': 'فشل!',
		'pleaseSelectServer': 'اختر الخادم',
		'pleaseInputRole': 'أدخِل اسم الشخصية',
		'inputToServer': 'ابحث عن الخادم',
		'codeUsed': 'تم استخدام الكود من قبل',
		'validRole': 'يرجى التحقق من شخصيتك بالفعل.',
		'validToGet': 'يرجى التحقق من شخصيتك أولاً قبل استلام تلك الباقة.',
		'goToValid': 'تحقق',
		'changeAccount': 'تغيير الحساب',
		"frequently" : "عملية شديدة التكرار، يرجى الانتظار قليلاً ثم إعادة المحاولة",
		'-20005':'فشلت الاستعادة. يرجى التأكد من معلومات الشخصية. (-20005)',
		'-20006':'فشلت الاستعادة. يرجى التأكد من الحساب أولاً. (-20006)',
		'-20007':'فشلت الاستعادة. يرجى التأكد من الخادم أولاً. (-20007)'
	},
}

// 对应语言的logo类名
export const logo = {
	'ar-sa': 'logo-ar',
	'en-us': 'logo-en',
	'ja-jp': 'logo-jp',
	'ko-kr': 'logo-kr',
	'zh-tw': 'logo-tw'
}
